import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import CustomSelect from "../CustomComponents/CustomSelect";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function ClientSiteDialog ({ handleDialogCallback }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    

    const initialValues = {
        Name: '',
		Address: '',
        City: '',
        State: '',
        Country: '',
        Zipcode: '',
        IsActive: false
    };

    const validFormSchema = Yup.object({
        Name: Yup
            .string('Enter a Client Site Name')
            .required('Client Site Name is Required'),
		Address: Yup
            .string('Enter Address')
            .required('Address is Required'),
        City: Yup
            .string('Enter City')
            .required('City is Required'),
        State: Yup
            .string('Enter State')
            .required('State is Required'),
        Country: Yup
            .string('Enter Country')
            .required('Country is Required'),
        Zipcode: Yup
            .string('Enter Zipcode')
            .required('Zipcode is Required'),
        IsActive:  Yup
            .boolean()
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
	        Name: values.Name,
			Address: values.Address,
	        City: values.City,
	        State: values.State,
	        Country: values.Country,
	        Zipcode: values.Zipcode,
	        IsActive: values.IsActive
        };

        handleDialogCallback(msg);
        handleClose();
    })

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    React.useEffect(() => {

    })

    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen}>
                Add Client Site
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                            ClientSites
                                        </Typography>
                                        <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Client Site Info:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="Name"
                                            variant="outlined"
                                            id="outlined-client-site-name"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Name}
                                            error={props.touched.Name && Boolean(props.errors.Name)}
                                            helperText={props.touched.Name && props.errors.Name}                                          
                                            label="Client Site Name"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="Address"
                                            variant="outlined"
                                            id="outlined-Address"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Address}
                                            error={props.touched.Address && Boolean(props.errors.Address)}
                                            helperText={props.touched.Address && props.errors.Address}                                          
                                            label="Address"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="City"
                                            variant="outlined"
                                            id="outlined-City"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.City}
                                            error={props.touched.City && Boolean(props.errors.City)}
                                            helperText={props.touched.City && props.errors.City}                                          
                                            label="City"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="State"
                                            variant="outlined"
                                            id="outlined-State"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.State}
                                            error={props.touched.State && Boolean(props.errors.State)}
                                            helperText={props.touched.State && props.errors.State}                                          
                                            label="State"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="Country"
                                            variant="outlined"
                                            id="outlined-Country"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Country}
                                            error={props.touched.Country && Boolean(props.errors.Country)}
                                            helperText={props.touched.Country && props.errors.Country}                                          
                                            label="Country"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="Zipcode"
                                            variant="outlined"
                                            id="outlined-Zipcode"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Zipcode}
                                            error={props.touched.Zipcode && Boolean(props.errors.Zipcode)}
                                            helperText={props.touched.Zipcode && props.errors.Zipcode}                                          
                                            label="Zipcode"
                                        />
                                    </FormControl>
                                </div>
                                <div>
	                                <FormControl sx={{ m: 1 }}>
	                                    <FormControlLabel
	                                        name="IsActive"
	                                        label="Active"
	                                        control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
	                                    />
	                                </FormControl>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>                
            </Dialog>
        </div>
    );
}